import('./draggable_grid.css')

function DraggableGrid(opts){
    let {container, grid_gap = {}, gaps = {x:10, y:10, type: 'px'}, items = [], resize = {w:{available:false},h:{available:false}}} = opts
    let context = this
    let elements = {}

    let dragging, resizing

    this.generate = () =>{
        // container = document.querySelector(container)
        elements.container = createElement('div', 'drag-grid-container', '')
        
        generateItems()
        eventHandlers()

        container.appendChild(elements.container)
    }

    this.addItem = item =>{
        items.push(item)
        this.reload()
    }

    this.setItems = new_items =>{
        items = new_items
        this.reload()
    }

    this.reload = () =>{
        elements.container.innerHTML = ""
        generateItems()
    }

    function eventHandlers(){
        document.addEventListener('mousedown', (event) => {
            if(items.map(x=>x.element).includes(event.target)){
                dragging = event.target;
            } else if(event.target.classList.contains('drag-grid-item-control')){
                resizing = event.target.parentNode
            } else if( event.target.classList.contains('drag-grid-item-text')){
                dragging = event.target.parentNode
            }
        });

        document.addEventListener('mousemove', (event) => {
            if (dragging) {
                
              resizing = undefined


              //o valor da posição do mouse já descontando offsets dos containers parent
              const offsetX = event.clientX - $(elements.container).offset().left - dragging.offsetWidth / 2;
              const offsetY = event.clientY - $(elements.container).offset().top - dragging.offsetHeight / 2;
              
              let x,y

              //lógica dos gaps
              if(gaps['type'] == 'px' || !gaps['type']){
                //arredondando para gap
                x = Math.round(offsetX / gaps['x']) * gaps['x']
                y = Math.round(offsetY / gaps['y']) * gaps['y']
              } else {
                //lógica dos gaps em porcentagem

                //convertendo os gaps de porcentagem pra pixel
                let step_x = elements.container.clientWidth * gaps['x'] / 100
                let step_y = elements.container.clientHeight * gaps['y'] / 100

                //arredondando para gap
                x = Math.round(offsetX / step_x) * step_x
                y = Math.round(offsetY / step_y) * step_y
              }
              
              move(dragging,x, y)

            } else if(resizing){
                dragging = undefined
                const offsetX = event.clientX - $(elements.container).offset().left
                if(resizing.clientWidth <= elements.container.clientWidth){
                    // resizing.style.width = x + 'px';
                    if(gaps['type'] == 'px' || !gaps['type']){
                        //arredondando para gap
                        let x = Math.round(offsetX / gaps['x']) * gaps['x']

                        resizing.style.width = x + 'px';
                        } else {
                        //lógica dos gaps em porcentagem

                        //convertendo os gaps de porcentagem pra pixel
                        let step_x = elements.container.clientWidth * gaps['x'] / 100

                        //arredondando para gap
                        let x = Math.round(offsetX / step_x) * step_x

                        if(x <= elements.container.clientWidth){
                            resizing.style.width = x + 'px';
                        }   
                    }
                }
            }
          });


          document.addEventListener('mouseup', () => {
            dragging = false;
            resizing = false;
          });
    }

    const move = (obj, x, y) =>{
        const validX = x =>{
            return x >= 0 && x + obj.clientWidth <= elements.container.clientWidth 
            
        }
        
        const validY = y =>{
            return elements.container.clientHeight > y && y >= 0
            
        }
        if(validX(x)){
            obj.style.left = x + 'px';
        }
    
        if(validY(y)){
            obj.style.top = y + 'px';
        }
    }

    function generateItems(){
        items.forEach(item=>{
            let control_right
            let el = createElement('div', 'drag-grid-item-wrapper', '')
            let text = createElement('div', 'drag-grid-item-text', item.title)

            if(resize.w.available){
                control_right = createElement('div', 'drag-grid-item-control', '')
                // control_right.appendChild(createElement('div'))
                control_right.classList.add('control-right')
            }

            el.appendChild(text)
            
            if(control_right){
                el.appendChild(control_right)
            }
            

            item.element = el

            if(item.attributes){
                if(item.attributes.x || item.attributes.y){
                    el.style.left = item.attributes.x + 'px'
                    el.style.top = item.attributes.y + 'px'
                    // move(el, item.attributes.x, item.attributes.y)
                } 
                if(item.attributes.w || item.attributes.h){
                    el.style.width = item.attributes.w + 'px'
                    el.style.height = item.attributes.h + 'px'
                }
                el.style.backgroundColor = item.attributes.color || '#' + Math.floor(Math.random()*16777215).toString(16);
            }

            elements.container.appendChild(el)
        })
    }


    function createElement(type, classList, content){
        let el = document.createElement(type)
        if(classList){
            el.classList.add(classList)
        }
        el.innerHTML = content
        return el
    }
}


export default DraggableGrid
